var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#FFF1F1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0413 8.32031C14.6776 8.32031 14.3452 8.52575 14.1826 8.85099L13.4879 10.2403H10.2412C9.71106 10.2403 9.28125 10.6701 9.28125 11.2003C9.28125 11.7305 9.71106 12.1603 10.2413 12.1603L10.2412 21.7603C10.2412 22.8207 11.1009 23.6803 12.1613 23.6803H19.8412C20.9016 23.6803 21.7612 22.8207 21.7612 21.7603V12.1603C22.2914 12.1603 22.7212 11.7305 22.7212 11.2003C22.7212 10.6701 22.2914 10.2403 21.7612 10.2403H18.5146L17.8199 8.85099C17.6573 8.52575 17.3249 8.32031 16.9613 8.32031H15.0413ZM13.1212 14.0803C13.1212 13.5501 13.5511 13.1203 14.0812 13.1203C14.6114 13.1203 15.0412 13.5501 15.0412 14.0803V19.8403C15.0412 20.3705 14.6114 20.8003 14.0812 20.8003C13.5511 20.8003 13.1212 20.3705 13.1212 19.8403V14.0803ZM17.9212 13.1203C17.3911 13.1203 16.9612 13.5501 16.9612 14.0803V19.8403C16.9612 20.3705 17.3911 20.8003 17.9212 20.8003C18.4514 20.8003 18.8812 20.3705 18.8812 19.8403V14.0803C18.8812 13.5501 18.4514 13.1203 17.9212 13.1203Z",
    fill: "#EE4441"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/deleteIcon.03d015231a3058951b74bb4e2cefcd70.svg";
export { ForwardRef as ReactComponent };